<template>
    <div class="footer">
        <div class="row">
            <div class="col-sm-6">
                <div class="updated-at">
                    <i class="material-icons">update</i>
                    Actualizado al:
                    <span class="date">{{
                        moment(updatedAt).format('DD/MM/YYYY')
                    }}</span>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="downloads text-right">
                    <a :href="csv(this.computedUrl)" target="_blank">
                        <i class="material-icons">file_download</i>
                        CSV
                    </a>
                    <a :href="this.computedUrl" target="_blank">
                        <i class="material-icons">file_download</i>
                        JSON
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';
export default {
    data: function() {
        return {
            updatedAt: this.$store.state.updatedAt
        };
    },
    props: ['url'],
    methods: {
        moment,
        csv(url) {
            return (
                url.slice(0, url.indexOf('?')) +
                '.csv' +
                url.slice(url.indexOf('?'))
            );
        }
    },
    computed: {
        computedUrl: function() {
            return _.isArray(this.url) ? this.url[0] : this.url;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/Common/Footer.vue